/**
 * NW Quantity Pack - Syncs selected quantity card to product form
 *
 * Flow:
 * 1. Quantity cards (name="nw-quantity-{sectionId}") select pack size
 * 2. Selected radio value is synced to form input[name="quantity"]
 * 3. If quantity input doesn't exist, creates a hidden one
 */

(function () {
  'use strict';

  const SELECTORS = {
    infoWrapper: '.product__info-wrapper',
    productForm: 'product-form',
    form: 'form[data-type="add-to-cart-form"]',
    quantityInput: 'input[name="quantity"]',
    quantityRadio: '.nw-qty-card__radio',
    quantityCards: '[data-nw-quantity-cards]',
  };

  /**
   * Gets the product form element within the given scope
   * @param {Element} scope - Parent element (e.g. product__info-wrapper)
   * @returns {HTMLFormElement|null}
   */
  function getProductForm(scope) {
    if (!scope) return null;
    const formEl = scope.querySelector(`${SELECTORS.productForm} ${SELECTORS.form}`);
    return formEl || null;
  }

  /**
   * Gets or creates the quantity input in the form.
   * Checks inside form first, then form-associated inputs, then creates one.
   * @param {HTMLFormElement} form - The product form
   * @returns {HTMLInputElement}
   */
  function getOrCreateQuantityInput(form) {
    if (!form) return null;

    let input = form.querySelector(SELECTORS.quantityInput);
    if (input) return input;

    input = document.querySelector(`input[name="quantity"][form="${form.id}"]`);
    if (input) return input;

    input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'quantity';
    input.value = '1';
    form.appendChild(input);
    return input;
  }

  /**
   * Gets the selected quantity from the quantity pack radios
   * @returns {string|null} Quantity value or null
   */
  function getSelectedQuantity() {
    const checked = document.querySelector(`${SELECTORS.quantityRadio}:checked`);
    return checked?.value || null;
  }

  /**
   * Syncs the selected quantity to the product form
   */
  function syncQuantityToForm() {
    const infoWrapper = document.querySelector(SELECTORS.infoWrapper);
    const form = getProductForm(infoWrapper);
    if (!form) return;

    const quantityInput = getOrCreateQuantityInput(form);
    if (!quantityInput) return;

    const quantity = getSelectedQuantity();
    if (!quantity) return;

    quantityInput.value = quantity;
  }

  /**
   * Binds change and click listeners to quantity radios
   */
  function bindListeners() {
    const infoWrapper = document.querySelector(SELECTORS.infoWrapper);
    if (!infoWrapper) return;

    const form = getProductForm(infoWrapper);
    if (!form) return;

    const hasQuantityCards = document.querySelector(SELECTORS.quantityCards);
    if (!hasQuantityCards) return;

    document.addEventListener('change', function handleQuantityChange(e) {
      if (!e.target.matches(SELECTORS.quantityRadio)) return;
      syncQuantityToForm();
    });

    document.addEventListener('click', function handleQuantityClick(e) {
      const cards = e.target.closest(SELECTORS.quantityCards);
      if (!cards) return;

      requestAnimationFrame(function () {
        requestAnimationFrame(syncQuantityToForm);
      });
    });
  }

  /**
   * Initializes the quantity pack sync
   */
  function init() {
    bindListeners();
    syncQuantityToForm();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
